<template>

  <section id="planos" class="d-flex align-items-center planos">

    <div class="container">

      <div class="section-title" data-aos="fade-up">
        <div class="row">
          <h1 data-aos="fade-up">Planos</h1>
          <h5 class="mb-5" data-aos="fade-up" data-aos-delay="400">Escolha o plano ideal para o seu negócio</h5>
        </div>

        <div class="row mb-5">
          <!--
          <div class="col-md-3 d-flex align-items-stretch pt-4 pt-xl-0" data-aos="fade-left" data-aos-delay="300">

            <div class="content d-flex flex-column justify-content-center">

              <div class="box" data-aos="zoom-in-left" data-aos-delay="200">
                <h3>Detalhes dos Planos</h3>
                <hr>

                <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150" style="color: #009587;">
                  <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Taxa de adesão <strong>grátis</strong>
                </div>

                <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                  <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Emissão 100% automática
                </div>

                <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                  <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Todas as Integrações
                </div>

                <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                  <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Cad. CNPJ com preenchimento automático
                </div>

                <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                  <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Atendimento via whatsapp, chat e e-mail
                </div>

                <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                  <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Importação de vendas (max. 500 vendas)
                </div>

                <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                  <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Acesso à API
                </div>

                <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                  <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Onboarding assistido
                </div>

                <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                  <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Apoio técnico para integração
                </div>

              </div>

            </div>

          </div>
          -->

          <div class="col-md-3 align-items-stretch pt-4 pt-xl-0" data-aos="fade-left" data-aos-delay="300">
            <div class="box" data-aos="zoom-in-left" data-aos-delay="200">
              <h3>Comece</h3>
              <h4>Grátis</h4>

              <div class="col-lg-12 mb-4" data-aos="fade-up" data-aos-delay="150">
                20 notas/mês
              </div>

              <div class="col-lg-12 mb-4" data-aos="fade-up" data-aos-delay="150">
                <strong>Utilizando o Greenn</strong>
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150" style="color: #009587;">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Taxa de adesão <strong>grátis</strong>
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Emissão automática e manual
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Relatório de notas fiscais emitidas
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Suporte técnico via whatsapp
              </div>

              <div class="col-lg-12" style="padding: 13px;"></div>

              <div class="btn-wrap">
                <a href="https://greenn.com.br" class="btn-buy">Assinar</a>
                <!--<a href="https://app.sigame.digital/register?plano=a5c9d75c-9898-4bb0-8c31-2400057cad4e" class="btn-buy">Assinar</a>-->
              </div>

            </div>
          </div>

          <div class="col-md-3 align-items-stretch pt-4 pt-xl-0" data-aos="fade-left" data-aos-delay="300">
            <div class="box recommended" data-aos="zoom-in-left" data-aos-delay="200">
              <h3>Plano 100</h3>
              <h4><sup>R$</sup>99<span> / mês</span></h4>

              <div class="col-lg-12 mb-4" data-aos="fade-up" data-aos-delay="150">
                100 notas/mês
              </div>
              <!--
              <div class="col-lg-12 mb-4" data-aos="fade-up" data-aos-delay="150">
                R$ 0,75 por nota adicional
              </div>
              -->

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150" style="color: #009587;">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Taxa de adesão <strong>grátis</strong>
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Emissão automática e manual
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Importação por arquivo CSV
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Relatório de notas fiscais emitidas
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Suporte técnico via whatsapp
              </div>

              <div class="col-lg-12" style="padding: 23px;"></div>

              <div class="btn-wrap">
                <a href="https://payfast.greenn.com.br/63499" class="btn-buy">Assinar</a>
                <!--<a href="https://app.sigame.digital/register?plano=a5c9d75c-9898-4bb0-8c31-2400057cad4e" class="btn-buy">Assinar</a>-->
              </div>

            </div>
          </div>

          <div class="col-md-3 align-items-stretch pt-4 pt-xl-0" data-aos="fade-left" data-aos-delay="300">
            <div class="box" data-aos="zoom-in" data-aos-delay="100">
              <h3>Plano 500</h3>
              <h4><sup>R$</sup>199<span> / mês</span></h4>

              <div class="col-lg-12 mb-4" data-aos="fade-up" data-aos-delay="150">
                500 notas/mês
              </div>
              <!--
              <div class="col-lg-12 mb-4" data-aos="fade-up" data-aos-delay="150">
                R$ 0,55 por nota adicional
              </div>
              -->

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150" style="color: #009587;">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Taxa de adesão <strong>grátis</strong>
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Emissão automática e manual
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Importação por arquivo CSV
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Relatório de notas fiscais emitidas
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Suporte técnico via whatsapp
              </div>

              <!--
              <div class="col-lg-12 opcoes mb-3" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Importação (máx. 500 vendas)
              </div>
              <div class="col-lg-12 opcoes mb-3" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Acesso à API
              </div>
              -->

              <div class="col-lg-12" style="padding: 23px;"></div>

              <div class="btn-wrap">
                <a href="https://payfast.greenn.com.br/63501" class="btn-buy">Assinar</a>
                <!--<a href="https://app.sigame.digital/register?plano=bf2f42e6-e241-435c-899d-e68405aefe9e" class="btn-buy">Assinar</a>-->
              </div>
            </div>
          </div>

          <div class="col-md-3 align-items-stretch pt-4 pt-xl-0" data-aos="fade-left" data-aos-delay="300">
            <div class="box" data-aos="zoom-in-left" data-aos-delay="200">
              <h3>Plano 1500</h3>
              <h4><sup>R$</sup>299<span> / mês</span></h4>

              <div class="col-lg-12 mb-4" data-aos="fade-up" data-aos-delay="150">
                1.500 notas/mês
              </div>
              <!--
              <div class="col-lg-12 mb-4" data-aos="fade-up" data-aos-delay="150">
                R$ 0,35 por nota adicional
              </div>
              -->

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150" style="color: #009587;">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Taxa de adesão <strong>grátis</strong>
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Emissão automática e manual
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Importação por arquivo CSV
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Relatório de notas fiscais emitidas
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Suporte técnico via whatsapp
              </div>

              <!--
              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Importação (máx. 1.500 vendas)
              </div>
              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Acesso à API
              </div>
              -->

              <div class="col-lg-12 opcoes mb-3" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Onboarding assistido
              </div>

              <div class="btn-wrap">
                <a href="https://payfast.greenn.com.br/63506" class="btn-buy">Assinar</a>
                <!--<a href="https://app.sigame.digital/register?plano=c33f7455-2232-4500-8031-401e14bf2bc5" class="btn-buy">Assinar</a>-->
              </div>
            </div>
          </div>

          <!--
            <div class="col-md-3 align-items-stretch pt-4 pt-xl-0" data-aos="fade-left" data-aos-delay="300">
              <div class="box" data-aos="zoom-in-left" data-aos-delay="200">
                <h3>Enterprise</h3>
                <div class="col-lg-12" data-aos="fade-up" data-aos-delay="150">
                  Acima de 1.500 notas/mês
                </div>
                <h4>Consulte</h4>
                <div class="col-lg-12 mb-4" data-aos="fade-up" data-aos-delay="150">
                  <strong>Plano Personalizado</strong>
                </div>

                <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150" style="color: #009587;">
                  <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Taxa de adesão <strong>grátis</strong>
                </div>

                <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                  <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Emissão 100% automática
                </div>

                <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                  <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Todas as Integrações
                </div>

                <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                  <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Atendimento via whatsapp
                </div>

                <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                  <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Importação (ilimitado)
                </div>
                <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                  <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Acesso à API
                </div>

                <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                  <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Onboarding assistido
                </div>

                <div class="col-lg-12 opcoes mb-3" data-aos="fade-up" data-aos-delay="150">
                  <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Apoio técnico para integração
                </div>

                <div class="btn-wrap">
                  <a class="btn-buy"
                  href="https://api.whatsapp.com/send/?phone=5544999329925&amp;text=Acessei%20o%20site%20do%20Sigame%20e%20gostaria%20de%20consultar%20plano%20personalizado.">
                    Consulte
                  </a>
                </div>
              </div>
            </div>
        -->

        </div>

        <div class="row mb-5">
          <div class="col-md-3 align-items-stretch pt-4 pt-xl-0" data-aos="fade-left" data-aos-delay="300">
            <div class="box" data-aos="zoom-in-left" data-aos-delay="200">
              <h3>Plano 3000</h3>
              <h4><sup>R$</sup>399<span> / mês</span></h4>

              <div class="col-lg-12 mb-4" data-aos="fade-up" data-aos-delay="150">
                3.000 notas/mês
              </div>
              <!--
              <div class="col-lg-12 mb-4" data-aos="fade-up" data-aos-delay="150">
                R$ 0,17 por nota adicional
              </div>
              -->

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150" style="color: #009587;">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Taxa de adesão <strong>grátis</strong>
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Emissão automática e manual
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Importação por arquivo CSV
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Relatório de notas fiscais emitidas
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Suporte técnico via whatsapp
              </div>

              <div class="col-lg-12 opcoes mb-3" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Onboarding assistido
              </div>

              <div class="btn-wrap">
                <a href="https://payfast.greenn.com.br/70927" class="btn-buy">Assinar</a>
              </div>
            </div>
          </div>

          <div class="col-md-3 align-items-stretch pt-4 pt-xl-0" data-aos="fade-left" data-aos-delay="300">
            <div class="box" data-aos="zoom-in-left" data-aos-delay="200">
              <h3>Plano 5000</h3>
              <h4><sup>R$</sup>499<span> / mês</span></h4>

              <div class="col-lg-12 mb-4" data-aos="fade-up" data-aos-delay="150">
                5.000 notas/mês
              </div>
              <!--
              <div class="col-lg-12 mb-4" data-aos="fade-up" data-aos-delay="150">
                R$ 0,16 por nota adicional
              </div>
              -->

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150" style="color: #009587;">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Taxa de adesão <strong>grátis</strong>
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Emissão automática e manual
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Importação por arquivo CSV
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Relatório de notas fiscais emitidas
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Suporte técnico via whatsapp
              </div>

              <div class="col-lg-12 opcoes mb-3" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Onboarding assistido
              </div>

              <div class="btn-wrap">
                <a href="https://payfast.greenn.com.br/70940" class="btn-buy">Assinar</a>
              </div>
            </div>
          </div>

          <div class="col-md-3 align-items-stretch pt-4 pt-xl-0" data-aos="fade-left" data-aos-delay="300">
            <div class="box" data-aos="zoom-in" data-aos-delay="100">
              <h3>Plano 7000</h3>
              <h4><sup>R$</sup>599<span> / mês</span></h4>

              <div class="col-lg-12 mb-4" data-aos="fade-up" data-aos-delay="150">
                7.000 notas/mês
              </div>
              <!--
              <div class="col-lg-12 mb-4" data-aos="fade-up" data-aos-delay="150">
                R$ 0,14 por nota adicional
              </div>
              -->

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150" style="color: #009587;">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Taxa de adesão <strong>grátis</strong>
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Emissão automática e manual
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Importação por arquivo CSV
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Relatório de notas fiscais emitidas
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Suporte técnico via whatsapp
              </div>

              <div class="col-lg-12 opcoes mb-3" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Onboarding assistido
              </div>

              <div class="btn-wrap">
                <a href="https://payfast.greenn.com.br/70942" class="btn-buy">Assinar</a>
              </div>
            </div>
          </div>

          <div class="col-md-3 align-items-stretch pt-4 pt-xl-0" data-aos="fade-left" data-aos-delay="300">
            <div class="box" data-aos="zoom-in-left" data-aos-delay="200">
              <h3>Plano 10000</h3>
              <h4><sup>R$</sup>699<span> / mês</span></h4>

              <div class="col-lg-12 mb-4" data-aos="fade-up" data-aos-delay="150">
                10.000 notas/mês
              </div>
              <!--
              <div class="col-lg-12 mb-4" data-aos="fade-up" data-aos-delay="150">
                R$ 0,13 por nota adicional
              </div>
              -->

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150" style="color: #009587;">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Taxa de adesão <strong>grátis</strong>
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Emissão automática e manual
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Importação por arquivo CSV
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Relatório de notas fiscais emitidas
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Suporte técnico via whatsapp
              </div>

              <div class="col-lg-12 opcoes mb-3" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Onboarding assistido
              </div>

              <div class="btn-wrap">
                <a href="https://payfast.greenn.com.br/70946" class="btn-buy">Assinar</a>
              </div>
            </div>
          </div>

        </div>

        <div class="row" style="padding-bottom: 50px;">
          <br>
          <br>
          <h1 data-aos="fade-up">Seu negócio precisa de mais notas fiscais?</h1>
          <h5 class="mb-3" data-aos="fade-up" data-aos-delay="400">Fale com a gente e solicite um plano personalizado para você.</h5>

          <div class="box-button" data-aos="zoom-in-left" data-aos-delay="200">
            <div class="btn-contato">
                <div class="btn-wrap">
                    <a class="btn-buy" style="text-decoration: none; padding: 15px 40px 12px 40px"
                      href="https://api.whatsapp.com/send/?phone=5544999329925&amp;text=Acessei%20o%20site%20do%20Sigame%20e%20gostaria%20de%20consultar%20plano%20personalizado.">
                      Consulte
                    </a>
                </div>
              </div>
          </div>

        </div>

      </div>

    </div>

</section>

</template>

<script>
export default {
  name: 'PlanoComp'
}
</script>

<style scoped lang="scss">
.planos {
  background-color: $plano-bg-color;
  padding: 5vh 1vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: -40px;
}

.planos .box {
  padding: 20px;
  background: $plano-box-bg-color;
  text-align: center;
  border-radius: 8px;
  border: 2px solid $bg-color-2;
  box-shadow: $plano-icon-box-box-shadow;
  transition: box-shadow 0.3s ease;
  border-radius: 8px; /* 40px; */
  z-index: 1;
}

.planos .box h3 {
  font-weight: 400;
  padding: 15px;
  margin-top: 15px;
  font-size: 26px;
  font-weight: 600;
  color: $color-base;
}

.planos .box h4 {
  font-size: 42px;
  color: $a-color;
  font-weight: 500;
  margin-bottom: 20px;
}

.planos .opcoes {
  margin: 0px 0px 0px 0px;
  font-size: 14px;
  text-align: left;
}

.planos .box .opcoes i {
  text-align: left;
}

.planos .box h4 sup {
  font-size: 20px;
  top: -15px;
  left: -3px;
}

.planos .box h4 span {
  color: $color-base;
  font-size: 16px;
  font-weight: 300;
}

.planos .box ul {
  padding: 0;
  list-style: none;
  color: $color-base;
  text-align: center;
  line-height: 20px;
  font-size: 14px;
}

.planos .box ul li {
  padding-bottom: 16px;
}

.planos .box ul i {
  color: $a-color;
  font-size: 18px;
  padding-right: 4px;
}

.planos .box .btn-wrap {
  padding: 15px;
  text-align: center;
}

.planos .box .btn-buy {
  display: inline-block;
  padding: 15px 40px 12px 40px;
  border-radius: 50px;
  border: 2px solid $a-color;
  color: $a-color;
  font-size: 14px;
  transition: 0.3s;
  width: 180px;
  text-decoration: none;
}

.planos .box .btn-buy:hover {
  border: 2px solid $a-color-hover;
  background: $a-color-hover;
  color: $bg-base;
}

.planos .box-button {
  margin-top: 10px;
  padding: 10px;
  text-align: center;
}

.planos .box-button .btn-contato a {
  display: inline-block;
  padding: 10px 40px 12px 40px;
  border-radius: 50px;
  border: 2px solid $a-color;
  color: $a-color;
  font-size: 14px;
  transition: 0.3s;
  width: 200px;
}

.planos .box-button .btn-contato a:hover {
  color: $bg-base;
  border: 2px solid $a-color-hover;
  background: $a-color-hover;
}

.planos .recommended {
  border-color: $a-color;
}

.planos .recommended .btn-buy {
  background: $a-color;
  color: $bg-base;
}

</style>
